import axios from "axios";
import { jwtDecode } from "jwt-decode";




const login = (username, password, navigate) => {
  return axios.post(axios.defaults.baseURL + "/auth/signin",
    {
      username,
      password
    }).then(response => {
      if (response?.error) {
        console.log("Restituisce l'errore al componente");
        return { error: response.error };
      } else {
        if (response.data.accessToken) {
          //localStorage.setItem("user", JSON.stringify(response.data));
          saveTokenInLocalStorage(response.data);
          // runLogoutTimer(1000000, navigate); //esce ogni tot sensa chiedere niente
          console.log('AUTHService.js login ok');
        };
        //  console.log("role"+ JSON.parse(localStorage.getItem('user').roles));
        return response.data;
      }
    }
    )
    .catch((error) => {
      console.log("CATCH");
      // console.log(error);
      // Converti l'errore in un formato utile al componente
      return {
        error: {
          message: error.response?.data?.message || error.code || error.message
        }
      };
    });


}

function saveTokenInLocalStorage(tokenDetails) {

  console.log("salvo in localStrorage.userDetails:");
  console.log(tokenDetails);
  console.log("tokenDetails.token");
  console.log(tokenDetails.accessToken);
  const decodedToken = jwtDecode(tokenDetails.accessToken);
  console.log(decodedToken);


  //const expiresIn = (decodedToken.exp * 1000) - Date.now();

  tokenDetails.expireDate = new Date(
    new Date().getTime() + decodedToken.exp * 1000,
  );

  localStorage.setItem("user", JSON.stringify(tokenDetails));

}


function runLogoutTimer(timer, navigate) {
  setTimeout(() => {
    //dispatch(Logout(history));
    logout(navigate);
  }, timer);
}



const getCurrentUser = () => {
  //   console.log('AUTHService.js getCurrentUser =' +localStorage.getItem('user'));
  return JSON.parse(localStorage.getItem('user'));
}

const isLoggedIn = () => {


  const token = localStorage.getItem('user');
  if (token != null) {
    let user;
    try {
      user = JSON.parse(token);
    } catch (e) {
      console.error(e); // error in the above string (in this case, yes)!
      return false;
    }
    if (user != null) {
      return true;
    }
    else
      return false;
  } else {
    return false;
  }

 

}

const isTokenOk = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.accessToken) {
    const decoded = jwtDecode(user.accessToken);
    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      // Token scaduto, esegui il logout o richiedi un nuovo token
      alert("Sessione scaduta. Effettua di nuovo il login.");
      // console.log("dopo alert");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      //console.log("rimosso user da localstorage");
      window.location.href = "/login";
      return false;

    } else {
      console.log("ToKEN OK ");
      return true;
    }

  } else {

    return false;
  }

}

const monitorTokenExpiration = (token) => {
  const decoded = jwtDecode(token);
  const expirationTime = decoded.exp * 1000; // Converti in millisecondi
  const timeUntilExpiration = expirationTime - Date.now();

  setTimeout(() => {
    alert("Il tuo token sta per scadere. Aggiorna la sessione!");
  }, timeUntilExpiration - 30000); // Avvisa 30sec  prima della scadenza
};



const isExpo = () => {
  const token = localStorage.getItem('user');
  if (token != null) {
    let user;
    try {
      user = JSON.parse(token);
    } catch (e) {
      console.error(e); // error in the above string (in this case, yes)!
      return false;
    }
    if (user != null) {
      return user.roles.includes("ROLE_ESPOSITORE");
    }
    else
      return false;
  } else {
    return false;
  }
}

const isAdmin = () => {
  const token = localStorage.getItem('user');
  if (token != null) {
    let user;
    try {
      user = JSON.parse(token);
    } catch (e) {
      console.error(e); // error in the above string (in this case, yes)!
      return false;
    }
    if (user != null) {
      return user.roles.includes("ROLE_ADMIN");
    }
    else
      return false;
  } else {
    return false;
  }
}


const isVerifier = () => {
const token = localStorage.getItem('user');
  if (token != null) {
    let user;
    try {
      user = JSON.parse(token);
    } catch (e) {
      console.error(e); // error in the above string (in this case, yes)!
      return false;
    }
    if (user != null) {
      return user.roles.includes("ROLE_VERIFICATORE");
    }
    else
      return false;
  } else {
    return false;
  }
}

const getRoles = () => {
 const token = localStorage.getItem('user');
  if (token != null) {
    let user;
    try {
      user = JSON.parse(token);
    } catch (e) {
      console.error(e); // error in the above string (in this case, yes)!
      return null;
    }
    if (user != null) {
      return user.roles;
    }
    else
      return null;
  } else {
    return null;
  }
}


const logout = (navigate) => {
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.removeItem("user");

  navigate('/login');
}




const AuthService = {
  login,
  logout,
  isLoggedIn,
  getCurrentUser,
  isAdmin, isExpo,
  isTokenOk, monitorTokenExpiration, getRoles, isVerifier
};

export default AuthService;